import React from 'react';
import { Link } from 'react-router-dom';
import { Calculator, Phone } from 'lucide-react';

const ContactActions = () => (
  <div className="fixed bottom-4 right-4 z-[60] flex flex-col gap-2">
    <a
      href="tel:+917398413465"
      aria-label="Call Frames by Gaurav"
      title="Call"
      className="grid h-10 w-10 place-items-center bg-black text-white shadow-lg transition-colors hover:bg-gray-800"
    >
      <Phone size={18} />
    </a>
    <Link
      to="/packages"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Get Quotation"
      title="Get Quotation"
      className="grid h-10 w-10 place-items-center border border-black bg-white text-black shadow-lg transition-colors hover:bg-gray-100"
    >
      <Calculator size={18} />
    </Link>
  </div>
);

export default ContactActions;
